module.exports = __webpack_public_path__ + "img/PhoneMockup.399d83be.png";